module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o, i, j, len, ref;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='content-wrapper-inner'>\n  <div class='section-wrapper'>\n    <h1>How you did it</h1>\n    <p>\n      Some projects call for research and interviews. Others require photography or design work. Learning what skills you've used in the past helps us connect you with the right opportunities.\n    </p>\n  </div>\n  <div class='profile-nav-container section-wrapper'>\n    <div class='add-projects-tabs'>\n      <h4 class='active'>Add skills</h4>\n    </div>\n  </div>\n  <div class='maskable section-wrapper' id='projects'>\n    <div class='content divider no-line registration-add-skills'>\n      <div class='js-projects-list loading'>");
      ref = Array(5);
      for (j = 0, len = ref.length; j < len; j++) {
        i = ref[j];
        $o.push("        <div class='js-project-row list-item-wrapper'>\n          <div class='collapsible-container list-item'>\n            <span class='icon icon-move sort-handle'></span>\n            <div class='collapsible-header'>\n              <div class='flex-wrapper'>\n                <div class='flex-checkbox'>\n                  <div class='checkbox-toggle'></div>\n                </div>\n                <div class='flex-column js-toggle-collapsible'>\n                  <h5></h5>\n                  <div class='subtext'></div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>");
      }
      $o.push("        <div class='gradient-tint'></div>\n      </div>\n    </div>\n    <div class='actions divider js-actions'>\n      <a class='back-button button medium secondary' href='" + ($e($c(this.addProjectsUrl))) + "'>Add more projects</a>\n      <a class='button hidden js-next-page medium transparent'>Add topics</a>\n      <a class='button js-add-skills medium primary'>Next</a>\n    </div>\n  </div>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/projects/templates/registration_skills.js.hamlc
// module id = 1541
// module chunks = 2